import { Zones } from './../Zones/Zones';
import React, { FC, useEffect, useState } from "react";
import { MinusIcon, PlusIcon } from "@heroicons/react/24/solid";
import NcModal from "shared/NcModal/NcModal";
import { useAuth } from 'contexts/AuthContext';
import { LocalitySelectedType } from 'data/types';
import { useTimer } from 'contexts/TimerContext';
import { useDeleteSeatsByLocalityMutation } from 'store/api';

export interface NcInputNumberProps {
  className?: string;
  defaultValue?: number;
  min?: number;
  max?: number;
  onChange?: (value: number) => void;
  label?: string;
  desc?: string;
  haveSelection?: boolean;
  localityId: string;
  enablePurchase: boolean;
  startTime: string;
  maxQuantity: number;
  currentQuantity: number;
  endTime: string;
  localitiesSelected: LocalitySelectedType[],
  setLocalitiesSelected: React.Dispatch<React.SetStateAction<LocalitySelectedType[]>>
}

const NcInputNumberLocalities: FC<NcInputNumberProps> = ({
  className = "w-full",
  defaultValue = 0,
  min = 0,
  max,
  onChange,
  label,
  desc,
  localityId,
  haveSelection=false,
  enablePurchase,
  startTime,
  maxQuantity,
  currentQuantity,
  endTime,
  // seatsSelected,
  // setSeatsSelected,
  localitiesSelected,
  setLocalitiesSelected
}) => {
  const [value, setValue] = useState(defaultValue);
  const {isLoggedIn} = useAuth();
  const { formattedTime, startTimer } = useTimer();
  const [isOpened, setIsOpened] = useState(false);
  const [deleteSeats] = useDeleteSeatsByLocalityMutation();
  
  useEffect(() => {
    setValue(defaultValue);
  }, [defaultValue]);

  const handleClickDecrement = () => {
    if (min >= value) return;
    setValue((state) => {
      return state - 1;
    });
    deleteSeats(localityId);
    setLocalitiesSelected(prevLocalities => {
      return prevLocalities.map(locality => 
        locality._id === localityId ? { ...locality, quantity: value-1,zones: locality.zones.map((zone: any) => ({ _id: zone._id, seats: [] })) } : locality
      );
    }
    );
    onChange && onChange(value - 1);
  };

  const handleClickIncrement = () => {
    if (max && max <= value) return;
    setValue((state) => {
      return state + 1;
    });    
    setLocalitiesSelected(prevLocalities => {
      return prevLocalities.map(locality => 
        locality._id === localityId ? { ...locality, quantity: value+1 } : locality
      );
    });
    onChange && onChange(value + 1);
  };

  const date = new Date(startTime);
  const message = `La compra de entradas estará disponible a partir del ${date.toLocaleDateString('es-ES')} a las ${date.toLocaleTimeString('es-ES', { hour: '2-digit', minute: '2-digit', hour12: false })}.`;
  const renderLabel = () => {
    return (
      <div className="flex flex-col">
        <span className="font-medium text-neutral-800 dark:text-neutral-200">
          {label}
        </span>
        {desc && (
          <span className="text-xs text-neutral-500 dark:text-neutral-400 font-normal">
            {desc}
          </span>
        )}
      </div>
    );
  };
  const renderSeats = () => {
    return (
      <div className="flex flex-col items-center animate-fadeIn">
        <span className="font-medium text-neutral-800 dark:text-neutral-200">
          <i className="las la-couch text-2xl"></i> 
        </span>
        <span className="text-xs text-neutral-500 dark:text-neutral-400 font-normal">
          <NcModal
              showCloseButton={false}
              closeOnClickOutside={false}
              isOpenProp={isOpened}
              renderTrigger={(openModal) => (
                <span
                  onClick={() => {
                    startTimer(600); 
                    setIsOpened(true);
                  }}
                  className="block mt-1 cursor-pointer items-center text-center"
                >
                  Seleccionar asientos
                </span>
              )}
              renderContent={()=><Zones localityId={localityId} maxSeats={value} endTime={endTime} setIsOpened={setIsOpened} localitiesSelected={localitiesSelected} setLocalitiesSelected={setLocalitiesSelected}/>}
              modalTitle={`Seleccionar Zona ${formattedTime}`}
            />
        </span>
      </div>
    );
  };

  return (
    <div
      className={`nc-NcInputNumber flex items-center justify-between space-x-5 ${className}`}
      data-nc-id="NcInputNumber"
    >
      {label && renderLabel()}
      {haveSelection && value > 0 && renderSeats()}

      <div
        className={`nc-NcInputNumber flex items-center justify-between w-28`}
      >
        
        <button
          className="w-8 h-8 rounded-full flex items-center justify-center border border-neutral-400 dark:border-neutral-500 bg-white dark:bg-neutral-900 focus:outline-none hover:border-neutral-700 disabled:hover:border-neutral-400 dark:disabled:hover:border-neutral-500 disabled:opacity-50 disabled:cursor-default"
          type="button"
          onClick={handleClickDecrement}
          disabled={min >= value}
        >
          <MinusIcon className="w-4 h-4" />
        </button>
        <span>{value}</span>
        <NcModal
          renderTrigger={(openModal) => (
            <button
            className="w-8 h-8 rounded-full flex items-center justify-center border border-neutral-400 dark:border-neutral-500 bg-white dark:bg-neutral-900 focus:outline-none hover:border-neutral-700 disabled:hover:border-neutral-400 dark:disabled:hover:border-neutral-500 disabled:opacity-50 disabled:cursor-default"
            type="button"
            onClick={isLoggedIn && enablePurchase && (maxQuantity>currentQuantity||maxQuantity===0) ? handleClickIncrement: ()=>openModal()}
            disabled={max ? max <= value : false}
            >
              <PlusIcon className="w-4 h-4" />
            </button>
          )}
          contentExtraClass="w-full sm:w-1/2"
          modalTitle="Advertencia"
          renderContent={() => 
            enablePurchase && !isLoggedIn?(
            <span className="block text-center text-neutral-700 dark:text-neutral-300">
              Para proceder con la compra, {` `}
              <a href="/login" target="_blank" rel="noopener noreferrer" className="underline">
                inicia sesión
              </a>
              . Si no tienes una cuenta, {` `}
              <a href="/signup" target="_blank" rel="noopener noreferrer" className="underline">
                regístrate aquí
              </a>
              .
            </span>
          ):
          (currentQuantity>=maxQuantity && maxQuantity>0) ?
            (<span className="block text-center text-neutral-700 dark:text-neutral-300">
              Solo puedes comprar un máximo de {maxQuantity} entradas.
            </span>):
          (
            <span className="block text-center text-neutral-700 dark:text-neutral-300">
              {message}
            </span>
          )
        }
        />
      </div>
    </div>
  );
};

export default NcInputNumberLocalities;
